import { apiClient } from '@/plugins/axios';

const getInfluencers = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/influencers?' + params.toString());
};

const getInfluencerById = async (id: number) => {
  return apiClient.get(`/influencers/${id}`);
};

const createInfluencer = async (data: any) => {
  return apiClient.post('/influencers', data);
};

const updateInfluencer = async (id: number, data: any) => {
  return apiClient.patch(`/influencers/${id}`, data);
};

const deleteInfluencer = async (id: number) => {
  return apiClient.delete(`/influencers/${id}`);
};

export default {
  getInfluencers,
  getInfluencerById,
  createInfluencer,
  updateInfluencer,
  deleteInfluencer,
};
